import { useState } from "react"; // Importe o useState para o aviso
import mail from "../../assets/icons/gmail.png";
import whatsApp from "../../assets/icons/whatsapp.png";

function Footer() {
  const [copied, setCopied] = useState(false);
  const currentYear = new Date().getFullYear();
  const email = "contato@accium.com.br";

  const handleCopyEmail = (e) => {
    e.preventDefault();
    navigator.clipboard.writeText(email);
    setCopied(true);

    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <>
      <footer id="contact" className="footer">
        <div className="footer-container">
          <div className="footer-item" style={{ position: "relative" }}>
            <img src={mail} alt="email" className="footer-icon" />
            <a
              href={`mailto:${email}`}
              onClick={handleCopyEmail}
              title="Clique para copiar o e-mail"
              className="email-link"
            >
              {email}
            </a>
            {copied && (
              <span
                style={{
                  position: "absolute",
                  top: "-25px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  backgroundColor: "#f67f28",
                  color: "#fff",
                  padding: "2px 8px",
                  borderRadius: "4px",
                  fontSize: "10px",
                  fontWeight: "bold",
                }}
              >
                Copiado!
              </span>
            )}
          </div>

          {/* WhatsApp Agrupado */}
          <div className="footer-item">
            <img src={whatsApp} alt="whatsapp" className="footer-icon" />
            <div className="whatsapp-links">
              <a
                href="https://wa.me/5549999140597"
                target="_blank"
                rel="noreferrer"
              >
                (49) 99914-0597
              </a>
              <span style={{ margin: "0 8px", opacity: 0.5 }}>|</span>
              <a
                href="https://wa.me/5549988722562"
                target="_blank"
                rel="noreferrer"
              >
                (49) 98872-2562
              </a>
            </div>
          </div>
        </div>

        <p className="footer-copy">
          © {currentYear} Accium. Todos os direitos reservados.
        </p>
      </footer>

      {/* Botão flutuante */}
      <a
        href="https://wa.me/5549999140597"
        className="whatsapp-float"
        target="_blank"
        rel="noreferrer"
      >
        <img src={whatsApp} alt="whatsapp" />
      </a>
    </>
  );
}

export default Footer;
